import React from 'react';
import { render } from '@testing-library/react';
import { Toast } from './Toast';

describe('Toast', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container, baseElement } = render(
			<Toast
				primaryActionName="Refresh"
				onPrimaryActionClick={jest.fn()}
				secondaryActionname="Check Status"
				onSecondaryActionClick={jest.fn()}
				onClose={jest.fn()}
				duration={0}
				title="Membership billing run is in process in the background."
				data-auto-sel="automation-selector"
			>
				The system will notify you once completed.
			</Toast>
		);

		/**
		 * NOTE: Using "baseElement" instead of "container" because
		 *       Toast is rendered in a portal
		 */
		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
